import {
  Button,
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
  useTheme,
} from '@mui/material'
import React, { useRef, useState } from 'react'
import { MdEmail } from 'react-icons/md'
import {
  alterarUsuarioEsqueciSenha,
  redefinirSenha,
} from '../../components/api'
import PasswordField from '../../components/PasswordField/PasswordField.js'
import { setInfo } from '../../components/alerts'

const RedefinirSenha = ({ voltarTelaLogin }) => {
  const theme = useTheme()
  const [loading, setLoading] = useState(false)
  const [passo, setPasso] = useState('email')

  const [usuario, setUsuario] = useState('')
  const [codigoEmail, setCodigoEmail] = useState('')
  const [senha, setSenha] = useState('')
  const inputs = useRef([])

  const handleInputChange = (index, event) => {
    const { value } = event.target
    if (/^[a-zA-Z0-9]*$/.test(value) && codigoEmail.length <= 6) {
      const newToken =
        codigoEmail.slice(0, index) + value + codigoEmail.slice(index + 1)
      setCodigoEmail(newToken.toUpperCase())

      if (value.length === 1 && index < 5) {
        inputs.current[index + 1].focus()
      }
    }
  }

  const handleBackspace = (index, event) => {
    const { value } = event.target
    if (value.length === 0 && index > 0) {
      inputs.current[index - 1].focus()
    }
  }

  const redefinir = async () => {
    setLoading(true)
    const res = await redefinirSenha(usuario)
    if (res.status) setPasso('codigoEmail')
    setLoading(false)
  }

  const handleUsuario = (e) => setUsuario(e.target.value)
  const handleSenha = (e) => setSenha(e.target.value)

  const alterarSenha = async () => {
    setLoading(true)
    const res = await alterarUsuarioEsqueciSenha({
      cdValidacao: codigoEmail,
      senhaNova: senha,
    })
    if (res.efetuarNovoLogin) {
      setInfo(res.dsMensagem)
      voltarTelaLogin()
    }
    setLoading(false)
  }

  switch (passo) {
    case 'email':
      return (
        <>
          <Grid item xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              margin="dense"
              label="Email"
              value={usuario}
              onChange={handleUsuario}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <MdEmail fontSize={24} fill={theme.palette.action.active} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              endIcon={
                loading ? <CircularProgress color="inherit" size={15} /> : null
              }
              disabled={loading}
              onClick={redefinir}
            >
              Recuperar senha
            </Button>
          </Grid>
        </>
      )
    case 'codigoEmail':
      return (
        <>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            {[...Array(6)].map((_, index) => (
              <input
                key={index}
                ref={(input) => (inputs.current[index] = input)}
                type="text"
                maxLength="1"
                value={codigoEmail[index] || ''}
                onChange={(event) => handleInputChange(index, event)}
                onKeyPress={(event) => handleBackspace(index, event)}
                className="m-1 h-16 w-16 rounded-md border-2 border-gray-600 text-center text-2xl font-bold transition-colors hover:border-primary-dark focus:border-primary-dark"
              />
            ))}
          </Grid>
          <Grid item xs={12}>
            <PasswordField
              fullWidth
              variant="outlined"
              margin="dense"
              label="Nova senha"
              value={senha}
              onChange={handleSenha}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              endIcon={
                loading ? <CircularProgress color="inherit" size={15} /> : null
              }
              disabled={loading}
              onClick={alterarSenha}
            >
              Avançar
            </Button>
          </Grid>
        </>
      )
    default:
      return null
  }
}

export default RedefinirSenha
